import React from 'react';
import { useParams } from 'react-router-dom';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import './Post.css';

// Registering the necessary components for the chart
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Post = () => {
  const { id } = useParams();
  const posts = {
    3: {
      title: "Career Path of a Frontend Developer",
      content: "Here is the roadmap showing how a frontend developer progresses through key skills:",
      roadmapData: {
        labels: ["Basic Web Development", "Advanced JavaScript", "Version Control", "Responsive Design", "React", "Portfolio Projects", "Industry Experience"],
        datasets: [
          {
            label: "Progress in Career",
            data: [20, 40, 50, 60, 80, 90, 100],
            backgroundColor: '#4caf50', // Green color for the progress bars
          },
        ],
      },
    },
  };

  const post = posts[id] || { title: "Post Not Found", content: "This post is unavailable." };

  return (
    <div className="post-detail">
      <h2>{post.title}</h2>
      <p>{post.content}</p>

      {post.roadmapData && (
        <div className="career-path">
          <h3>Frontend Developer Roadmap</h3>
          <Bar data={post.roadmapData} options={{
            responsive: true,
            plugins: {
              title: {
                display: true,
                text: 'Skills Development Over Time',
                font: { size: 18 },
              },
              tooltip: {
                callbacks: {
                  label: function(tooltipItem) {
                    return tooltipItem.raw + '%';
                  },
                },
              },
            },
          }} />
        </div>
      )}
    </div>
  );
};

export default Post;
